import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=b503da34&scoped=true&"
import script from "./forget.vue?vue&type=script&lang=ts&"
export * from "./forget.vue?vue&type=script&lang=ts&"
import style0 from "./forget.vue?vue&type=style&index=0&id=b503da34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b503da34",
  null
  
)

component.options.__file = "forget.vue"
export default component.exports